import React, { useCallback, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import back from "../../Assets/Image/admin/back.png";
import close from "../../Assets/Image/admin/close.png";
import { CircleMinus, CirclePlus, CircleX, Upload } from 'lucide-react';
import { addQuestion } from '../../Services/ApiServices';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie';
import { Circles } from 'react-loader-spinner';
import Dialog from '../../Base-Component/Dialog/Dialog';
import { IMG_URL } from '../../Services/Api';
import Cropper from 'react-easy-crop';

function AddQuestions() {
    const navigate = useNavigate();
    const imageRef = useRef(null);
    const { id } = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [cropModal, setCropModal] = useState(false);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [isIndex, setIsIndex] = useState(0)
    const [thumbnails, setThumbnails] = useState([])
    const [questionsList, setQuestionsList] = useState([
        {
            id: 1,
            title: "",
            question: "",
            options: [{ value: "", isCorrect: false }],
            file: null,
            fileType: "",
            correctOption: "",
            errors: {
                title: "",
                question: "",
                file: "",
                options: "",
                correctOption: "",
            }
        }
    ]);

    const handleFiles = async (images) => {
        const thumbnailss = [];
        // for (let i = 0; i < images.length; i++) {
        const file = images;
        if (file.type.includes('video') && file.type === "video/mp4") {
            try {
                const thumbnail = await generateThumbnailFromVideo(file);
                let videoFile = base64ToFile(thumbnail, "thumbnail.jpg", 'image/jpeg');
                thumbnailss.push(videoFile);
                setThumbnails(thumbnailss);
            } catch (error) {
                console.error('Error generating thumbnail:', error);
            }
        } else {
            setThumbnails([])
        }
        // }
    };

    const generateThumbnailFromVideo = (videoFile) => {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.crossOrigin = 'anonymous';

            video.onloadedmetadata = () => {
                try {
                    const duration = video.duration;
                    if (isNaN(duration) || duration === Infinity) {
                        throw new Error('Invalid video duration');
                    }
                    const middleTime = duration / 2;
                    video.currentTime = middleTime;
                } catch (error) {
                    reject(new Error(`Error in onloadedmetadata`));
                }
            };

            video.onseeked = () => {
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const context = canvas.getContext('2d');
                    if (context) {
                        context.drawImage(video, 0, 0, canvas.width, canvas.height);
                        const thumbnailData = canvas.toDataURL('image/jpeg');
                        resolve(thumbnailData);
                    } else {
                        throw new Error('Canvas context is null');
                    }
                } catch (error) {
                    reject(new Error(`Error in onseeked`));
                }
            };

            video.onerror = (error) => {
                console.error('Video error event:', error);
                reject(new Error('Error loading or seeking video.'));
            };

            video.src = URL.createObjectURL(videoFile);
        });
    };

    const base64ToFile = (base64String, filename, mimeType) => {
        const base64Content = base64String.split(',')[1];
        const byteCharacters = atob(base64Content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        const file = new File([blob], filename, { type: mimeType });
        return file;
    };

    // Handle file selection
    const handleFile = (qIndex, e) => {
        const file = e.target.files[0];
        handleFiles(file)
        const updatedQuestions = [...questionsList];
        updatedQuestions[qIndex].file = file;
        updatedQuestions[qIndex].fileType = file.type.includes('video') ? 'video' : 'image';
        setQuestionsList(updatedQuestions);
    };

    // Remove selected file
    const removeFile = (qIndex) => {
        const updatedQuestions = [...questionsList];
        updatedQuestions[qIndex].file = null;
        updatedQuestions[qIndex].fileType = "";
        setQuestionsList(updatedQuestions);
    };

    // Handle title change
    const handleTitleChange = (index, value) => {
        const updatedQuestions = [...questionsList];
        updatedQuestions[index].title = value;
        setQuestionsList(updatedQuestions);
    };

    // Handle question change
    const handleQuestionChange = (index, value) => {
        const updatedQuestions = [...questionsList];
        updatedQuestions[index].question = value;
        setQuestionsList(updatedQuestions);
    };

    // Handle option value change
    const handleOptionChange = (qIndex, oIndex, value) => {
        const updatedQuestions = [...questionsList];
        updatedQuestions[qIndex].options[oIndex].value = value;
        setQuestionsList(updatedQuestions);
    };

    // Handle correct option selection
    const handleCorrectOptionChange = (qIndex, oIndex) => {
        const updatedQuestions = [...questionsList];
        const selectedCorrectOption = updatedQuestions[qIndex].options[oIndex].value;
        updatedQuestions[qIndex].options = updatedQuestions[qIndex].options.map((option, idx) => ({
            ...option,
            isCorrect: idx === oIndex
        }));
        updatedQuestions[qIndex].correctOption = selectedCorrectOption;
        setQuestionsList(updatedQuestions);
    };

    // Add a new question
    const addNewQuestion = () => {
        setQuestionsList([...questionsList, {
            id: questionsList.length + 1,
            title: "",
            question: "",
            options: [{ value: "", isCorrect: false }],
            file: null,
            fileType: "",
            correctOption: "",
            errors: {
                title: "",
                question: "",
                file: "",
                options: "",
                correctOption: "",
            }
        }]);
    };

    // Add a new option to a question
    const addNewOption = (qIndex) => {
        const updatedQuestions = [...questionsList];
        updatedQuestions[qIndex].options.push({ value: "", isCorrect: false });
        setQuestionsList(updatedQuestions);
    };

    // Remove an option from a question
    const removeOption = (qIndex, oIndex) => {
        const updatedQuestions = [...questionsList];
        updatedQuestions[qIndex].options.splice(oIndex, 1);
        setQuestionsList(updatedQuestions);
    };

    // Validate fields
    const validateFields = () => {
        let isValid = true;
        const updatedQuestions = [...questionsList];

        updatedQuestions.forEach((question, qIndex) => {
            let fileError = "";

            if (!question.file) {
                fileError = "Image/Video is required";
            } else if (question.fileType === "video" && question.file.type !== "video/mp4") {
                fileError = "Only MP4 videos are allowed";
            }

            const errors = {
                question: question.question.trim() === "" ? "Question is required" : "",
                file: fileError,
                options: question.options.some(option => option.value.trim() === "") ? "All options must be filled" : "",
                correctOption: question.correctOption.trim() === "" ? "Correct option must be selected" : "",
            };

            updatedQuestions[qIndex].errors = errors;
            if (Object.values(errors).some(error => error !== "")) {
                isValid = false;
            }
        });

        setQuestionsList(updatedQuestions);
        return isValid;
    };

    // Handle form submission
    const handleSubmit = () => {
        setIsLoading(true)
        if (validateFields()) {

            const filesArray = questionsList.map((question) => question.file).filter(file => file !== null);

            const questionDatas = questionsList.map((question) => ({
                question_text: question.question,
                quiz_id: id,
                media_type: filesArray[0].type.includes('video') ? "video" : "image",
                correct_answer: question.correctOption,
                answers: question.options.map(option => ({
                    answer_text: option.value,
                    is_correct: option.isCorrect,
                }))
            }));
            const formData = new FormData()

            formData.append("question_image", filesArray[0])
            formData.append("data", JSON.stringify(questionDatas))
            if (thumbnails.length) {
                formData.append("thumbnail", thumbnails[0])
            }
            addQuestion(formData)
                .then((res) => {
                    toast.success(res.data.message)
                    navigate("/quiz/question/" + id)
                    setIsLoading(false)
                })
                .catch((err) => {
                    if (err.response.status == 401) {
                        Cookies.remove("e_learning_token")
                        navigate("/login")
                    } else {
                        toast.error(err.response.data.message)
                    }
                    setIsLoading(false)
                })
        } else {
            console.log("Validation failed");
            setIsLoading(false)
        }
    };

    // Remove a question
    const removeQuestion = (index) => {
        const updatedQuestions = [...questionsList];
        updatedQuestions.splice(index, 1);
        setQuestionsList(updatedQuestions);
    };

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const getCroppedImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                questionsList[isIndex].file ? URL.createObjectURL(questionsList[isIndex].file) : "",
                croppedAreaPixels
            );
            console.log("Cropped Image: ", croppedImage);
        } catch (e) {
            console.error("Crop failed:", e);
        }
    }, [croppedAreaPixels, IMG_URL]);

    const getCroppedImg = (imageSrc, croppedAreaPixels) => {
        console.log("img src >>", imageSrc)
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = imageSrc;
            image.setAttribute('crossOrigin', 'anonymous');

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = croppedAreaPixels.width;
                canvas.height = croppedAreaPixels.height;

                ctx.drawImage(
                    image,
                    croppedAreaPixels.x,
                    croppedAreaPixels.y,
                    croppedAreaPixels.width,
                    croppedAreaPixels.height,
                    0,
                    0,
                    croppedAreaPixels.width,
                    croppedAreaPixels.height
                );

                const base64Image = canvas.toDataURL('image/jpeg');

                fetch(base64Image)
                    .then((res) => res.blob())
                    .then((blob) => {
                        const file = new File([blob], "cropped-image.jpg", {
                            type: "image/jpeg",
                        });
                        console.log("file >>", file)
                        const updatedQuestions = [...questionsList];
                        updatedQuestions[isIndex].file = file;
                        updatedQuestions[isIndex].fileType = 'image';
                        setQuestionsList(updatedQuestions);
                    });
            };

            image.onerror = (error) => {
                reject(error);
            };
        });
    };


    return (
        <>
            <div className='md:m-4 m-1 fontNew'>
                <div className='flex sm:flex-nowrap flex-wrap justify-between mb-3'>
                    <div className='flex items-center cursor-pointer mb-4'>
                        <img src={back} onClick={() => { navigate(`/quiz/question/${id}`) }} className='w-4' alt="back" />
                        <p onClick={() => { navigate(`/quiz/question/${id}`) }} className='text-base font-medium ms-3 p-0'>Go back</p>
                    </div>
                    {/* <div className='flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full'>
                    <div>
                        <button className="ml-2 text-green-700 flex border-2 border-green-700 py-2 px-3 rounded-lg font-medium" onClick={addNewQuestion}>
                            <Plus color="Green" size={24} /> Add Question
                        </button>
                    </div>
                </div> */}
                </div>

                <div className="grid grid-span-12">
                    {questionsList.map((question, qIndex) => (
                        <div key={qIndex} className='col-span-12 bg-white p-5 rounded-lg my-3'>
                            {/* <label className='text-lg font-medium'>Title {qIndex + 1}</label> */}
                            <h4 className='text-lg font-medium mt-4'>Question {qIndex + 1}</h4>
                            {/* <input
                                type="text"
                                className='border-2 px-4 py-3 rounded-md w-full outline-[#e1c595] mt-3'
                                placeholder='Enter title'
                                value={question.title}
                                onChange={(e) => handleTitleChange(qIndex, e.target.value)}
                            />
                            {question.errors.title && <p className="text-red-500 text-sm mt-1">({question.errors.title})</p>} */}

                            <input
                                type="text"
                                className='border-2 px-4 py-3 rounded-md w-full outline-[#e1c595] mt-3'
                                placeholder='Enter question'
                                value={question.question}
                                onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
                            />
                            {question.errors.question && <p className="text-red-500 text-sm mt-1">({question.errors.question})</p>}

                            <div className='flex items-center mt-4'>
                                <div className="w-full p-5 border-2 border-dashed rounded-md shadow-sm border-slate-300/60 dark:border-darkmode-400">
                                    <div className="relative cursor-pointer h-52 w-full image-fit flex justify-center items-start">
                                        {question.file ? (
                                            question.fileType === "video" ? (
                                                <>
                                                    <video controls className="rounded-md h-52">
                                                        <source src={URL.createObjectURL(question.file)} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <div className='w-6 h-6 cursor-pointer' onClick={() => removeFile(qIndex)}>
                                                        <img src={close} className='w-6 h-6 -ms-4 -mt-2 relative' alt="close" />
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <img className="rounded-md h-52" alt="Question" src={URL.createObjectURL(question.file)} />
                                                    <div className='w-6 h-6 cursor-pointer' onClick={() => removeFile(qIndex)}>
                                                        <img src={close} className='w-6 h-6 -ms-4 -mt-2 relative' alt="close" />
                                                    </div>
                                                </>
                                            )
                                        ) : (
                                            <p className="flex justify-center items-center h-52">No media found</p>
                                        )}
                                    </div>
                                    <div className="flex justify-center items-center mt-4">
                                        <div className="relative flex items-center justify-center cursor-pointer">
                                            <Upload className='text-blue-600 mr-2' size={18} />
                                            <span className="mr-1 text-blue-600">Upload Image/Video</span>
                                            <input
                                                type="file"
                                                accept="image/*, video/*"
                                                className="absolute w-full h-full top-0 left-0 opacity-0 cursor-pointer"
                                                onChange={(e) => handleFile(qIndex, e)}
                                            />
                                        </div>
                                        <div>
                                            {question.file && question.fileType != "video" ? (
                                                <b
                                                    className="cursor-pointer underline sm:text-base text-sm"
                                                    onClick={(e) => { setCropModal(true); setIsIndex(qIndex) }}
                                                >
                                                    Crop Image
                                                </b>
                                            ) : ("")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {question.errors.file && <p className="text-red-500 text-sm mt-1">({question.errors.file})</p>}

                            <div className='mt-3'>
                                <label className='text-lg font-medium'>Options</label>
                            </div>
                            {question.options.map((option, oIndex) => (
                                <div key={oIndex} className="flex items-center gap-2 my-3">
                                    <input
                                        type="radio"
                                        className="h-5 w-5 mr-3"
                                        checked={option.isCorrect}
                                        onChange={() => handleCorrectOptionChange(qIndex, oIndex)}
                                    />
                                    <input
                                        type="text"
                                        className='border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]'
                                        placeholder='Enter option'
                                        value={option.value}
                                        onChange={(e) => handleOptionChange(qIndex, oIndex, e.target.value)}
                                    />
                                    {oIndex == 0 ?
                                        (
                                            <button
                                                className='px-2'
                                                onClick={() => addNewOption(qIndex)}
                                            >
                                                <CirclePlus color="green" />
                                            </button>
                                        )
                                        :
                                        (
                                            <button className='px-2'>
                                                <CircleMinus onClick={() => removeOption(qIndex, oIndex)} color='red' />
                                            </button>
                                        )}
                                </div>
                            ))}
                            {question.errors.options && <p className="text-red-500 text-sm mt-1">({question.errors.options})</p>}
                            {question.errors.correctOption && <p className="text-red-500 text-sm mt-1">({question.errors.correctOption})</p>}

                            {qIndex > 0 && (
                                <button className="text-red-700 mt-5 flex border-2 border-red-700 py-2 px-3 rounded-lg font-medium" onClick={() => removeQuestion(qIndex)}>
                                    - Remove Question
                                </button>
                            )}
                        </div>
                    ))}
                </div>

                <div className="w-full flex justify-end">
                    <button disabled={isLoading} onClick={handleSubmit} className="bg-green-700 text-white h-[45px] w-[200px] mt-5 rounded-lg">
                        {isLoading ? (
                            <div className='flex justify-center'>
                                <Circles
                                    width={25}
                                    height={25}
                                    color="#fff"
                                    ariaLabel="circles-loading"
                                    wrapperStyle={{}}
                                    visible={true}
                                    wrapperClass=""
                                />
                            </div>
                        ) : (
                            "Submit Questions"
                        )}
                    </button>
                </div>
            </div>

            <Dialog
                open={cropModal}
                onClose={() => setCropModal(false)}
                initialFocus={imageRef}
                size="lg"
            >
                <Dialog.Panel className=" w-full mx-auto bg-white px-5 pt-2">
                    <Dialog.Title className="flex justify-between text-lg font-medium">
                        Crop Image
                        <CircleX color="gray" size={28} onClick={() => setCropModal(false)} className='cursor-pointer' />
                    </Dialog.Title>
                    <Dialog.Description className="mt-4">
                        <div className="relative w-full h-[400px]">
                            <Cropper
                                image={questionsList[isIndex].file ? URL.createObjectURL(questionsList[isIndex].file) : ""}
                                crop={crop}
                                zoom={zoom}
                                aspect={297 / 210}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        </div>
                    </Dialog.Description>
                    <Dialog.Footer className="flex justify-end mt-4">
                        <button
                            className="w-24 bg-[#00987C] px-4 py-2 rounded-lg text-white"
                            type="button"
                            onClick={() => {
                                getCroppedImage();
                                setCropModal(false);
                            }}
                        >
                            Submit
                        </button>
                    </Dialog.Footer>
                </Dialog.Panel>
            </Dialog>
        </>
    );
}

export default AddQuestions;